import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';

import { REQUEST_SIZE_INTERNAL_SHARED_USERS } from '../../components/SocialButtons/Share/InternalShare/constants/share';

import { gqlRequest } from '../../helpers/request';
import { getFormattedSharedUser } from '../../helpers/user';
import * as iShareSelectors from '../selectors/teamShare';
import { getSharedTeamListAction, setSharedTeamListAction } from '../slices/teamShare';

const queryGQL = `
  query hostedWatchGetSharedTeamList(
    $page: Int,
    $pageSize: Int,
    $status: Int,
    $sortBy: String,
    $sortOrder: String,
    $videoId: String!,
  ) {
    hostedWatchGetSharedTeamList(
      page: $page,
      pageSize: $pageSize,
      status: $status,
      sortBy: $sortBy,
      sortOrder: $sortOrder,
      videoId: $videoId,
    ) {
      recordsTotal
      page
      pageSize
      records {
        id
        email,
        firstName,
        lastName,
        role,
        status
      }
    }
  }
`;

export default (action$, state$) =>
  action$.pipe(
    ofType(getSharedTeamListAction.type),
    mergeMap(({ payload: { videoId, isAddRequest } }) => {
      const userList = iShareSelectors.userList(state$.value);

      const indexPage = isAddRequest ? Math.floor(userList.length / REQUEST_SIZE_INTERNAL_SHARED_USERS) : 0;

      return gqlRequest({
        query: queryGQL,
        variables: {
          page: indexPage + 1,
          pageSize: REQUEST_SIZE_INTERNAL_SHARED_USERS,
          status: 1,
          sortBy: 'firstName',
          sortOrder: 'asc',
          videoId,
        },
      }).pipe(
        map(({ data, errors }) => {
          const payload = {
            totalCount: 0,
            page: 1,
            userList,
          };

          if (!errors.length) {
            const { recordsTotal, page, records } = data.hostedWatchGetSharedTeamList;

            payload.totalCount = recordsTotal;
            payload.page = page;

            const formattedUserList = records.map(getFormattedSharedUser);

            payload.userList = isAddRequest ? userList.concat(formattedUserList) : formattedUserList;
          }

          return setSharedTeamListAction(payload);
        }),
      );
    }),
  );
